//import { pilot } from '~/services/serviceInstances';

interface Request {
  modelId: string;
}

interface Response {
  doc_ids: string[];
}

export const getModelFailedDocs = async ({
  modelId,
}: Request): Promise<Response> => {
  //TODO: implement api request once it is available
  console.log('modelId', modelId);

  // Mock response for testing
  const mockResponse: Response = {
    doc_ids: [
      'doc-12345-abcde',
      'doc-67890-fghij',
      'doc-11111-klmno',
      'doc-22222-pqrst',
      'doc-33333-uvwxy',
    ],
  };

  // Uncomment when API is ready:
  // const response: Response = await pilot.get(`/model/${modelId}/failed-docs`);
  // return response;

  // Return mock data for now
  return Promise.resolve(mockResponse);
};
